import React from 'react';
import { motion } from 'framer-motion';
import { Brain, PenTool, Rocket, Layout } from 'lucide-react';
const steps = [{
  id: 1,
  title: 'Nos Contás de Tu Negocio',
  description: 'Nos escribís por WhatsApp, nos contás tus servicios, especialidades y qué tipo de clientes buscás.',
  icon: Brain,
  color: 'text-purple-400'
}, {
  id: 2,
  title: 'Creamos Tu Página Web',
  description: 'Diseñamos una página web profesional que muestra tus servicios y genera confianza al instante.',
  icon: PenTool,
  color: 'text-pink-400'
}, {
  id: 3,
  title: 'Conectamos Todo',
  description: 'WhatsApp, dominio propio, Meta Ads para atraer clientes. Todo integrado.',
  icon: Layout,
  color: 'text-cyan-400'
}, {
  id: 4,
  title: 'Empezás a Recibir Clientes',
  description: 'Tu página sale al aire y los clientes empiezan a contactarte. Así de simple.',
  icon: Rocket,
  color: 'text-yellow-400'
}];
export function MethodSection() {
  return <section id="metodo" className="py-24 bg-[#050510] relative" data-id="element-204">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-205">
        <div className="text-center mb-20" data-id="element-206">
          <h2 className="text-3xl md:text-5xl font-bold font-orbitron mb-4" data-id="element-207">
            Así de Fácil <span className="text-gradient-cosmic" data-id="element-208">Funciona</span>
          </h2>
          <p className="text-gray-400 max-w-2xl mx-auto" data-id="element-209">
            De la idea a recibir clientes en 4 pasos simples
          </p>
        </div>

        <div className="relative" data-id="element-210">
          {/* Connecting Line (Desktop) */}
          <div className="hidden md:block absolute top-1/2 left-0 w-full h-0.5 bg-gradient-to-r from-purple-900 via-pink-900 to-purple-900 -translate-y-1/2 z-0" data-id="element-211" />

          <div className="grid grid-cols-1 md:grid-cols-4 gap-12 relative z-10" data-id="element-212">
            {steps.map((step, index) => <motion.div key={step.id} initial={{
            opacity: 0,
            y: 50
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: index * 0.2
          }} className="relative group" data-id="element-213">
                <div className="flex flex-col items-center text-center" data-id="element-214">
                  <div className="relative mb-6" data-id="element-215">
                    <div className="w-20 h-20 rounded-full bg-[#0a0a1a] border-2 border-purple-500/30 flex items-center justify-center group-hover:border-pink-500 group-hover:shadow-[0_0_20px_rgba(236,72,153,0.5)] transition-all duration-300 z-10" data-id="element-216">
                      <step.icon className={`w-8 h-8 ${step.color}`} data-id="element-217" />
                    </div>
                    <div className="absolute -top-2 -right-2 w-8 h-8 rounded-full bg-gradient-to-br from-purple-600 to-pink-600 flex items-center justify-center text-white font-bold text-sm shadow-lg" data-id="element-218">
                      {step.id}
                    </div>
                  </div>

                  <h3 className="text-xl font-bold text-white mb-3 font-orbitron" data-id="element-219">
                    {step.title}
                  </h3>
                  <p className="text-gray-400 text-sm leading-relaxed" data-id="element-220">
                    {step.description}
                  </p>
                </div>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
}